export default __webpack_public_path__ + "static/media/ProximaNova-RegularItalic.0f82cb07.otf";